import { type ReactNode } from "react";

type BadgeVariant = "success" | "warning" | "error" | "info" | "soft" | "neutral";

interface BadgeProps {
  variant?: BadgeVariant;
  children: ReactNode;
}

export function Badge({ variant = "neutral", children }: BadgeProps) {
  return <span className={`xpn-badge xpn-badge--${variant}`}>{children}</span>;
}
